import { erpApi } from "@/shared/axios";
import { ROUTER_PATHS, urlBackend } from "@/shared/constants";
import { AlertSeverityEnum, UseMutationsParams } from "@/shared/interfaces";
import { ISolicitudCanje, ISolicitudCanjeParams, ISolicitudCanjeResp } from "@/shared/interfaces/erp/marketing/solicitudCanje.interface";
import { getUrlParamsFetch, handleAxiosError } from "@/shared/utils";
import { useUiStore } from "@/store/ui";
import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";


const { get, post, put } = erpApi()

//** get
export const useFetchSolicitudCanje = (
  params: ISolicitudCanjeParams,
  enabled: boolean = true
) => {
  return useQuery({
    queryKey: ['solicitudCanje', ...Object.values(params || {})],
    queryFn: async () => {
      return await getSolicitudCanje(params ?? {})
    },
    
    enabled
  })
}

export const getSolicitudCanje = async (data: ISolicitudCanjeParams) => {
  const queryParams = getUrlParamsFetch(data || {})
  return await get<ISolicitudCanjeResp>(`${urlBackend}api/v1/solicitudcanje/?${queryParams}`, true);
}

//** get Buscar solicitud Canje por id*/
export const useFetchGetByIdSolicitudCanje = (
  id: string
) => {
  return useQuery({
    queryKey: ['solicitudCanje', id],
    queryFn: async () => {
      return await getByIdSolicitudCanje(id)
    },
    refetchOnWindowFocus: false,
    gcTime: 100, //para vaciar caché en la versión actual de react query
  })
}

export const getByIdSolicitudCanje = async (id: string) => {
  return await get(`${urlBackend}api/v1/solicitudcanje/${id}/`, true)
}

//* crear una solicitud Canje 
export const useFetchPostSolicitudCanje = (
  {
    enableSuccessAlert=true,
    navigate,
    enableRedirect = true,
    returnUrl,
  }: UseMutationsParams

) => {
  const queryClient = useQueryClient()
  const setAlert = useUiStore(s => s.setAlert);
  return useMutation({
    mutationFn: postSolicitudCanje,
    onSuccess: (data) => {
      queryClient.invalidateQueries({ queryKey: ['solicitudcanje'] })

      enableSuccessAlert
        && setAlert(true, data.message, AlertSeverityEnum.success)

      navigate && enableRedirect && navigate(returnUrl ?? ROUTER_PATHS.marketing.solicitudesCanjeEventoNav)
    },
    onError: (error) => handleAxiosError(error)
  })
}

export const postSolicitudCanje = async (data: ISolicitudCanjeParams) => {
  return await post<ISolicitudCanje>(`${urlBackend}api/v1/solicitudcanje/`, data, true)
}
//* Actualizar la solictud Canje 
export const useFetchPutSolicitudCanje = (
  {
    enableSuccessAlert,
    navigate,
    returnUrl
  }: UseMutationsParams
) => {
  const queryClient = useQueryClient();
  const setAlert = useUiStore(s => s.setAlert);
  return useMutation({
    mutationFn: putSolicitudCanje,
    onSuccess:(data)=>{
      queryClient.invalidateQueries({queryKey:['solicitudcanje', data.data.id_solicitud_canje]})
      enableSuccessAlert
      && setAlert(true,data.message, AlertSeverityEnum.success)
      navigate && returnUrl && navigate(returnUrl)
    },
    onError:(error)=> handleAxiosError(error)
  })
}
export const putSolicitudCanje = async (data: ISolicitudCanjeParams) => {
  return await put<ISolicitudCanje>(`${urlBackend}api/v1/solicitudcanje/${data.id_solicitud_canje}/`, data, true)
}